import { createRoot } from "react-dom/client";
import { App, initTheme, unregister } from "@cayo/core";

initTheme(["fontAwesome"]);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(<App />);

unregister();
